import { useTranslation } from 'react-i18next';
import errorBoundaryIllustration from '../../assets/images/common/error_boundary_illustration.svg';
import { BaseButton } from '../shared/Buttons';
import styles from './_errorBoundary.module.scss';

export const ErrorBoundary = () => {
  const { t } = useTranslation();

  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className={styles.wrapper} data-testid="cw-explorer-error-boundary">
      <div className={styles.container}>
        <img src={errorBoundaryIllustration} alt="" />
        <div className={styles.textWrapper}>
          <h1 className="typo typo--h1 typo--neutral-100">{t('error_boundary.title')}</h1>
          <p className="typo typo--subtitle-1 typo--neutral-90">
            {t('error_boundary.subtitle_long')}
          </p>
          <p className="typo typo--subtitle-1 typo--neutral-90">
            {t('error_boundary.subtitle_short')}
          </p>
        </div>
        <div>
          <BaseButton onClick={reloadPage} size="large" variant="primary" className={styles.button}>
            {t('error_boundary.reload_button')}
          </BaseButton>
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundary;
